import React from 'react'
import { Icon } from './QuizListCheck.elements'

type Props = {
    className?: string
}

export const QuizListCheckIcon = ({ className }: Props) => (
    <Icon
        aria-hidden
        className={className}
        fill="none"
        focusable={false}
        role="img"
        viewBox="0 0 34 34"
    >
        <path d="M26.1322 33.9632C29.931 33.9632 33.0105 30.8836 33.0105 27.0849C33.0105 23.2861 29.931 20.2065 26.1322 20.2065C22.3334 20.2065 19.2539 23.2861 19.2539 27.0849C19.2539 30.8836 22.3334 33.9632 26.1322 33.9632Z" fill="#4CA9ED"/>
        <path d="M23.5 27.6665L25.1667 29.3332L29.3333 25.1665" stroke="white"/>
        <path d="M16.8333 30.1667H1.86719C1.38825 30.1667 1 29.7784 1 29.2995V1.86719C1 1.38825 1.38825 1 1.86719 1H28.4661C28.9451 1 29.3333 1.38825 29.3333 1.86719V18.7365" stroke="#1A1C1F"/>
        <path d="M6.41731 11.8335H23.9174C25.0679 11.8335 26.0007 12.7662 26.0007 13.9168V13.9168C26.0007 15.0674 25.0679 16.0002 23.9174 16.0002H6.41731C5.26672 16.0002 4.33398 15.0674 4.33398 13.9168V13.9168C4.33398 12.7662 5.26672 11.8335 6.41731 11.8335Z" stroke="#1A1C1F"/>
        <path d="M17.6673 23.5H6.4173C5.26672 23.5 4.33398 24.4327 4.33398 25.5833C4.33398 26.7339 5.26672 27.6667 6.4173 27.6667H16.834" stroke="#1A1C1F"/>
        <path d="M26.0007 19.0554C26.0007 18.2883 25.3788 17.6665 24.6118 17.6665H6.4173C5.26672 17.6665 4.33398 18.5992 4.33398 19.7498C4.33398 20.9004 5.26672 21.8332 6.4173 21.8332H19.334" stroke="#1A1C1F"/>
        <path d="M9.33398 8.8335H21.0007" stroke="#1A1C1F"/>
        <path d="M6.83398 7.1665H23.5007" stroke="#1A1C1F"/>
        <path d="M11.834 4.6665H18.5007" stroke="#1A1C1F"/>
        <path d="M14.334 19.3332L15.1673 20.1665L16.4173 18.9165" stroke="#1A1C1F"/>
    </Icon>
)
